// Ready-to-paste connection snippets for AI assistants. The token is the one-time secret
// returned by POST /api/api-tokens/create.
export const MCP_PACKAGE = "@connexxtion/mcp";

export function buildConnectionCommands({ token, apiUrl }) {
  const env = { CONNEXXTION_API_URL: apiUrl, CONNEXXTION_API_TOKEN: token };

  return {
    claudeCode:
      `claude mcp add connexxtion -e CONNEXXTION_API_URL=${apiUrl} ` +
      `-e CONNEXXTION_API_TOKEN=${token} -- npx -y ${MCP_PACKAGE}`,

    codex: [
      "[mcp_servers.connexxtion]",
      'command = "npx"',
      `args = ["-y", "${MCP_PACKAGE}"]`,
      `env = { CONNEXXTION_API_URL = "${apiUrl}", CONNEXXTION_API_TOKEN = "${token}" }`,
    ].join("\n"),

    claudeDesktop: JSON.stringify(
      { mcpServers: { connexxtion: { command: "npx", args: ["-y", MCP_PACKAGE], env } } },
      null,
      2,
    ),
  };
}
